module.exports = __webpack_public_path__ + "img/paidVacation.a53855a5.png";